export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t wam-hairline pt-24 pb-10" data-testid="wam-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div
          aria-hidden
          className="wam-deboss select-none pointer-events-none leading-[0.75]"
          style={{ fontSize: "18vw" }}
        >
          WAM
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 border-t wam-hairline pt-10 font-mono text-[10px] tracking-[0.24em] text-[#F0ECE4]/45">
          <div>
            <div className="text-[#C9A84C] mb-2">SMALL BUSINESS AUTOMATOR</div>
            <a href="mailto:dallas@smallbusinessautomator.com" className="hover:text-[#F0ECE4] transition-colors">
              dallas@smallbusinessautomator.com
            </a>
          </div>
          <div className="flex flex-wrap gap-4 md:justify-center">
            <a href="/privacy" className="hover:text-[#F0ECE4] transition-colors">PRIVACY</a>
            <span className="text-[#F0ECE4]/20">·</span>
            <a href="/terms" className="hover:text-[#F0ECE4] transition-colors">TERMS</a>
            <span className="text-[#F0ECE4]/20">·</span>
            <a href="/disclaimer" className="hover:text-[#F0ECE4] transition-colors">DISCLAIMER</a>
          </div>
          <div className="md:text-right">
            © 2026 SMALL BUSINESS AUTOMATOR · ALL RIGHTS RESERVED
          </div>
        </div>
      </div>
    </footer>
  );
}
